<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-content font-main">
                <div class="bg-white w-full rounded-xl p-3" v-click-away="hide">
                    <div class="text-center text-xl pt-1.5 text-a-red-fe2526 font-medium" v-html="title"></div>
                    <div class="text-center text-14 pb-1.5 pt-2 leading-relaxed" v-html="message"></div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "AlertNonButtonModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function () {
        return {
            open: false,

            message: '',
            title: '',
            busModal: null,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function () {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function (config) {
            this.title = config.title
            this.message = config.msg;

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickParent: function(){

        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

.modal {
    @extend %modal;
}
</style>
